// Dependency-free horizontal bar chart (HTML/CSS). Sorted descending; good for
// many categories where a radar would be cluttered. Optional year-ago compare
// shows a thin secondary bar + "current / previous" values.

const fmt = (n) => Math.round(Number(n) || 0).toLocaleString('en-US')

export default function BarChartH({ data = [], color = '#16a34a', prevColor = '#94a3b8', compare = false, emptyText = 'ไม่มีข้อมูล' }) {
  const rows = [...data].sort((a, b) => (b.value || 0) - (a.value || 0))
  if (!rows.length) return <div className="flex items-center justify-center text-[13px] text-slate-400 h-[200px]">{emptyText}</div>
  const max = Math.max(1, ...rows.map((r) => Math.max(r.value || 0, compare ? r.prev || 0 : 0)))
  return (
    <div className="space-y-2 pt-1">
      {rows.map((r) => {
        const pct = ((r.value || 0) / max) * 100
        const pctPrev = compare ? ((r.prev || 0) / max) * 100 : 0
        return (
          <div key={r.key} className="flex items-center gap-2.5 text-[12px]">
            <div className="w-24 shrink-0 truncate text-right text-slate-600" title={r.label}>{r.label}</div>
            <div className="flex-1 min-w-0">
              <div className="h-3.5 rounded bg-slate-100">
                <div className="h-full rounded" style={{ width: `${pct}%`, background: color, minWidth: pct > 0 ? 2 : 0 }} />
              </div>
              {compare && (
                <div className="h-1.5 mt-0.5 rounded" style={{ width: `${pctPrev}%`, background: prevColor, minWidth: pctPrev > 0 ? 2 : 0 }} />
              )}
            </div>
            <div className="w-[70px] shrink-0 text-right tabular-nums font-semibold text-slate-800">
              {fmt(r.value)}
              {compare && <span className="font-normal text-slate-400"> / {fmt(r.prev)}</span>}
            </div>
          </div>
        )
      })}
    </div>
  )
}
